import React, { useState, useEffect } from 'react';
import { Button } from './Button';
import { TicketIcon, MagnifyingGlassIcon, GavelIcon } from './IconComponents';

interface ServicesSliderProps {
  onOpenContactModal: (subject?: string) => void;
}

const sliderData = [
  {
    icon: <TicketIcon className="w-20 h-20" />,
    title: `¿Has recibido una multa de tráfico?`,
    subtitle: `NO LA PAGUES SIN CONSULTAR.`,
    description: `Podemos recurrirla y ahorrarte dinero y puntos. Déjanos analizar tu caso sin compromiso.`,
    buttonText: `Consulta tu Multa`,
    subject: `Consulta sobre Multa de Tráfico`,
    theme: {
      bg: 'bg-blue-600',
      iconText: 'text-blue-300',
      buttonClasses: 'bg-white hover:bg-gray-100 !text-blue-700 focus:ring-blue-500'
    }
  },
  {
    icon: <MagnifyingGlassIcon className="w-20 h-20" />,
    title: `¿Necesitas un informe pericial?`,
    subtitle: `NO ACEPTES UN ACUERDO INJUSTO.`,
    description: `Una prueba técnica irrefutable puede cambiar el resultado de tu caso. Nuestros expertos te darán la ventaja que necesitas.`,
    buttonText: `Solicita Informe`,
    subject: `Solicitud de Informe Pericial`,
    theme: {
      bg: 'bg-yellow-500',
      iconText: 'text-yellow-200',
      buttonClasses: 'bg-white hover:bg-gray-100 !text-yellow-700 focus:ring-yellow-500'
    }
  },
  {
    icon: <GavelIcon className="w-20 h-20" />,
    title: `¿Tu caso tiene que ir a juicio?`,
    subtitle: `NO TE ENFRENTES SOLO AL PROCESO.`,
    description: `Contar con un abogado especialista es crucial para tu defensa. Lucharemos por tus derechos hasta el final.`,
    buttonText: `Contacta con Abogado`,
    subject: `Consulta para Representación Judicial`,
    theme: {
      bg: 'bg-red-600',
      iconText: 'text-red-300',
      buttonClasses: 'bg-white hover:bg-gray-100 !text-red-700 focus:ring-red-500'
    }
  }
];

export const ServicesSlider: React.FC<ServicesSliderProps> = ({ onOpenContactModal }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % sliderData.length);
    }, 5000); // Change slide every 5 seconds
    return () => clearTimeout(timer);
  }, [currentIndex]);
  
  const goToSlide = (slideIndex: number) => {
    setCurrentIndex(slideIndex);
  };

  return (
    <section className="relative w-full overflow-hidden text-white">
      <div
        className="flex transition-transform duration-700 ease-in-out"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {sliderData.map((slide, index) => (
          <div
            key={index}
            className={`w-full flex-shrink-0 py-20 ${slide.theme.bg}`}
          >
            <div className="container mx-auto px-6 text-center flex flex-col items-center">
              <div className={`mb-6 ${slide.theme.iconText}`}>
                {slide.icon}
              </div>
              <h2 className="text-3xl md:text-4xl font-bold mb-2">
                {slide.title}
              </h2>
              <p className="text-xl md:text-2xl font-bold mb-6 text-yellow-300">
                {slide.subtitle}
              </p>
              <p className="text-lg md:text-xl mb-10 max-w-2xl mx-auto">
                {slide.description}
              </p>
              <Button onClick={() => onOpenContactModal(slide.subject)} size="large" variant="secondary" className={slide.theme.buttonClasses}>
                {slide.buttonText}
              </Button>
            </div>
          </div>
        ))}
      </div>
      
      <div className="absolute bottom-5 left-1/2 -translate-x-1/2 flex space-x-3">
        {sliderData.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-3 h-3 rounded-full transition-all duration-300 ${
              currentIndex === index ? 'bg-white scale-125' : 'bg-white/50 hover:bg-white/75'
            }`}
            aria-label={`Ir a la diapositiva ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
};
